import React from 'react'

import styles from './styles.module.scss'
import { useSubstate } from 'react-substate'
import substates from '../../../modules/substates'
import Modal from '../../_shared/Modal/Modal'

const DeletedTasks = () => {
    const [tasks] = useSubstate(substates.tasks)

    return (
        <Modal title='Recently Deleted'>
            {
                tasks.deleted.map((taskId) => (
                    <div
                        key={taskId}
                        className={styles.DeletedTask}
                    >
                        {tasks.db[taskId].text}
                    </div>
                ))
            }
        </Modal>
    )
}

export default DeletedTasks
